module.exports = function() {
  return new Worker(__webpack_public_path__ + "ccd318ab5f478347f8d6.worker.js");
};